"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundingSourceFormValidation = void 0;
const validates_1 = require("core/helpers/validates");
const FundingSourceFormValidation = (values, translate) => {
    const formErrors = {
        name: (0, validates_1.required)(values.name, translate),
        positionStatus: !values.staff && !values.freelance ? translate('mandatory_choose_types', 'სავალდებულოა ერთ-ერთი ტიპის არჩევა') : undefined
    };
    const errors = {};
    Object.entries(formErrors).forEach(([key, value]) => {
        if (value)
            errors[key] = value;
    });
    return errors;
};
exports.FundingSourceFormValidation = FundingSourceFormValidation;
